/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Muscles_PillInputs */

const en_us2_wrapped_muscles_pill = /** @type {(inputs: Wrapped_Muscles_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets per muscle · last week`)
};

const pt_br2_wrapped_muscles_pill = /** @type {(inputs: Wrapped_Muscles_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries por músculo · semana passada`)
};

const es_419_wrapped_muscles_pill = /** @type {(inputs: Wrapped_Muscles_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series por músculo · semana pasada`)
};

const pt_pt2_wrapped_muscles_pill = /** @type {(inputs: Wrapped_Muscles_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries por músculo · semana passada`)
};

const fr_fr2_wrapped_muscles_pill = /** @type {(inputs: Wrapped_Muscles_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries par muscle · semaine dernière`)
};

const de_de2_wrapped_muscles_pill = /** @type {(inputs: Wrapped_Muscles_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze pro Muskel · letzte Woche`)
};

const it_it2_wrapped_muscles_pill = /** @type {(inputs: Wrapped_Muscles_PillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie per muscolo · settimana scorsa`)
};

/**
* | output |
* | --- |
* | "Sets per muscle · last week" |
*
* @param {Wrapped_Muscles_PillInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_pill = /** @type {((inputs?: Wrapped_Muscles_PillInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_PillInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_pill(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_pill(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_pill(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_pill(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_pill(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_pill(inputs)
	return en_us2_wrapped_muscles_pill(inputs)
});
export { wrapped_muscles_pill as "wrapped.muscles_pill" }